module.exports = __webpack_public_path__ + "static/media/logo.bd1213b4.png";